<ion-content>
  <ion-item
    *ngFor="let item of items"
    lines="none"
    detail="false"
    button
    (click)="toggleVisibility(item)"
    data-test-selector="highlight-menu-3d">
    <ion-toggle
      [checked]="item.Highlighted"
      color="primary"
      labelPlacement="start"
      justify="space-between">
      {{ item.Translation }}
    </ion-toggle>
  </ion-item>
</ion-content>
